import React from 'react'
import { Switch, Route } from 'react-router-dom'
// import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { Main, About, Projects, Contact } from './Pages'

const Routes = () => {
	return (
		<Switch>
			<Route exact path="/" component={Main} />
			<Route path="/about" component={About} />
			<Route path="/projects" component={Projects} />
			<Route path="/contacts" component={Contact} />
		</Switch>
	)
}

export default Routes
